var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page5-container" },
    [
      (_vm.isWritingMessage && !_vm.isMobile()) || _vm.isMobile()
        ? _c("div", { staticClass: "page5-content-container" }, [
            _vm.isMobile()
              ? _c(
                  "div",
                  { staticClass: "categories-container no-scrollbar" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "buttons-container" },
                      _vm._l(_vm.occasionFilters.slice(0, 3), function(
                        occasion
                      ) {
                        return _c(
                          "button",
                          {
                            key: occasion,
                            staticClass: "step-button",
                            class: _vm.selectedCardsOccasions.includes(occasion)
                              ? "selected"
                              : "",
                            on: {
                              click: function($event) {
                                return _vm.setSelectedOccasion(occasion)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " \n                " +
                                _vm._s(occasion) +
                                "\n                "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "happybox-button white border more",
                        on: {
                          click: function($event) {
                            return _vm.showFilters()
                          }
                        }
                      },
                      [_vm._v("More Filters")]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "content-header" }, [
              _vm.steps[2] && _vm.steps[2].html
                ? _c("div", {
                    staticClass: "title",
                    domProps: { innerHTML: _vm._s(_vm.steps[2].html) }
                  })
                : _c("p", { staticClass: "title" }, [
                    _vm._v("Step 3: Select a Card")
                  ]),
              _vm._v(" "),
              _c("p", { staticClass: "subtitle" }, [
                _vm._v("We'll handwrite your message for you, "),
                _c("br"),
                _vm._v(" or you can "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.skipCard()
                      }
                    }
                  },
                  [_vm._v("SKIP THE CARD HERE")]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "header-container",
                attrs: { id: "header-container" }
              },
              [
                _c("div", { staticClass: "placeholder-recommendations" }, [
                  _c("div", { staticClass: "buttons-container" }, [
                    _c(
                      "button",
                      {
                        staticClass: "happybox-button white border",
                        class: !_vm.selectedCardsOccasions.includes("View All")
                          ? "selected"
                          : "",
                        on: {
                          click: function($event) {
                            return _vm.showFilters()
                          }
                        }
                      },
                      [
                        !_vm.selectedCardsOccasions.includes("View All")
                          ? _c("img", {
                              staticClass: "purple",
                              attrs: {
                                src:
                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
                              }
                            })
                          : _c("img", {
                              staticClass: "normal",
                              attrs: {
                                src:
                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"
                              }
                            }),
                        _vm._v(
                          "\n                        Filters \n                        "
                        ),
                        !_vm.selectedCardsOccasions.includes("View All")
                          ? _c("span", [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.selectedCardsOccasions.length) +
                                  ")"
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "cards-container" },
              [
                !_vm.selectedCardsOccasions.includes("View All")
                  ? _c("p", { staticClass: "other-gifts" }, [
                      _vm._v(_vm._s(_vm.selectedCardsOccasions.join(", ")))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.sortedCards.length == 0
                  ? _c("p", { staticClass: "over-budget" }, [
                      _vm._v("You're currently over your allotted budget. "),
                      _c("br"),
                      _vm._v(
                        " Please remove some items from your gift to be able to add more items."
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.sortedCards, function(card) {
                  return _c("li", { key: card.id }, [
                    _c("div", { staticClass: "card-container" }, [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "main-image-container",
                            class:
                              _vm.selectedCard && _vm.selectedCard.id == card.id
                                ? "selected"
                                : ""
                          },
                          [
                            _vm.selectedCard && _vm.selectedCard.id == card.id
                              ? _c("img", {
                                  staticClass: "green-check",
                                  attrs: {
                                    src:
                                      "https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "main-image lazyload",
                              attrs: {
                                width: "280",
                                height: "280",
                                "data-src": _vm._f("getProductImage")(card)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selectCard(card)
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(card.title))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "card-price" }, [
                          _vm._v(_vm._s(_vm._f("moneyFormat")(card)))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "happybox-button white border",
                          on: {
                            click: function($event) {
                              return _vm.selectCard(card)
                            }
                          }
                        },
                        [_vm._v("Select Design")]
                      )
                    ])
                  ])
                })
              ],
              2
            )
          ])
        : !_vm.isMobile()
        ? _c("div", { staticClass: "write-message-container" }, [
            _c("div", { staticClass: "card-image-container" }, [
              _c("img", {
                staticClass: "lazyload",
                attrs: {
                  width: "280",
                  height: "280",
                  "data-src": _vm._f("getProductImage")(_vm.selectedCard)
                }
              }),
              _vm._v(" "),
              _c("div", [
                _c("p", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(_vm.selectedCard.title))
                ]),
                _vm._v(" "),
                !_vm.isMobile()
                  ? _c(
                      "button",
                      {
                        staticClass: "blue-span",
                        on: { click: _vm.closeCard }
                      },
                      [_vm._v("Change Card")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isMobile()
                  ? _c("p", { staticClass: "purple-span" }, [
                      _vm._v(
                        "Type in your message below. One of our team members will hand write your message and pack it in with your box."
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "write-container",
                class: _vm.isBlankMessage ? "blank" : ""
              },
              [
                _vm.noMessageCurrentCard === false
                  ? _c("div", [
                      !_vm.isMobile()
                        ? _c("p", { staticClass: "purple-span" }, [
                            _vm._v(
                              "Type in your message below. One of our team members will hand write your message and pack it in with your box."
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.remainingCharacters < 0
                        ? _c("p", { staticClass: "red-span" }, [
                            _vm._v(
                              "Your message has a limit of 200 characters. Keep it short and sweet!"
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p"),
                      _vm._v(" "),
                      _c("div", { staticClass: "blank-card-container" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isBlankMessage,
                              expression: "isBlankMessage"
                            }
                          ],
                          attrs: { id: "blankCard", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.isBlankMessage)
                              ? _vm._i(_vm.isBlankMessage, null) > -1
                              : _vm.isBlankMessage
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.isBlankMessage,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.isBlankMessage = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.isBlankMessage = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.isBlankMessage = $$c
                                }
                              },
                              function($event) {
                                return _vm.changeBlankMessage()
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "blankCard" } }, [
                          _vm._v("Click here if you want your card blank")
                        ])
                      ])
                    ])
                  : _c("div", [
                      _c("p", { staticClass: "no-message" }, [
                        _vm._v("This card comes digitally printed.")
                      ])
                    ]),
                _vm._v(" "),
                !_vm.isBlankMessage
                  ? _c("div", { staticClass: "form-container" }, [
                      _c("div", { staticClass: "message-container" }, [
                        _c("label", { attrs: { for: "message" } }, [
                          _vm._v("Your Message:")
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.message,
                              expression: "message"
                            }
                          ],
                          attrs: {
                            placeholder: "Start typing here...",
                            maxlength: "200",
                            cols: "30",
                            rows: "3",
                            id: "message"
                          },
                          domProps: { value: _vm.message },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.message = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "from-container" }, [
                        _c("label", { attrs: { for: "from" } }, [
                          _vm._v("From:")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.from,
                              expression: "from"
                            }
                          ],
                          attrs: {
                            placeholder: "Your Name",
                            maxlength: "200",
                            id: "from",
                            type: "text"
                          },
                          domProps: { value: _vm.from },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.from = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "purple-span",
                            class: _vm.remainingCharacters == 0 ? "red" : ""
                          },
                          [
                            _vm._v(
                              "Character Remaining " +
                                _vm._s(_vm.remainingCharacters)
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "date-button",
                    on: {
                      click: function() {
                        _vm.openCalendar = !_vm.openCalendar
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://cdn.shopify.com/s/files/1/1363/8433/files/calendar.svg?v=1670856557"
                      }
                    }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.dateButton) +
                        "\n                "
                    ),
                    _c("span", { staticClass: "arrow down" })
                  ]
                ),
                _vm._v(" "),
                _c("date-picker", {
                  attrs: {
                    id: "datepicker",
                    format: "MM-DD-YYYY",
                    type: "date",
                    valueType: "timestamp",
                    "default-value": _vm.minDate,
                    "disabled-date": _vm.disabledDates,
                    editable: false,
                    open: _vm.openCalendar
                  },
                  on: {
                    "update:open": function($event) {
                      _vm.openCalendar = $event
                    },
                    close: _vm.checkDate
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "footer",
                      fn: function(ref) {
                        var emit = ref.emit
                        return [
                          _c(
                            "div",
                            { staticStyle: { "text-align": "right" } },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "mx-btn mx-btn-text",
                                  on: {
                                    click: function($event) {
                                      return _vm.clearDate(emit)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        Clear\n                    "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.selectedDate,
                    callback: function($$v) {
                      _vm.selectedDate = $$v
                    },
                    expression: "selectedDate"
                  }
                }),
                _vm._v(" "),
                _vm.messages && _vm.messages.length > 0
                  ? _c(
                      "p",
                      {
                        staticClass: "purple-link",
                        on: {
                          click: function() {
                            this$1.messageModal = true
                          }
                        }
                      },
                      [_vm._v("See Curated Messages!")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isMobile()
                  ? _c(
                      "button",
                      {
                        staticClass: "happybox-button green border",
                        class: _vm.isLoading ? "isLoading" : "",
                        attrs: { disabled: _vm.buttonDisabled },
                        on: {
                          click: function($event) {
                            return _vm.openCart()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.buttonText))]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "write-message-page",
          class:
            !_vm.isWritingMessage && _vm.isMobile() ? "expanded" : "collapsed",
          on: { click: _vm.closeCard }
        },
        [
          !_vm.isWritingMessage && _vm.isMobile()
            ? _c(
                "div",
                {
                  staticClass: "write-message-container",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm.isMobile()
                    ? _c(
                        "div",
                        {
                          staticClass: "separator-container",
                          on: {
                            touchstart: _vm.dragStart,
                            touchend: _vm.dragEnd
                          }
                        },
                        [_c("p", [_vm._v("Time to write your card message!")])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-image-container" }, [
                    _c("img", {
                      attrs: {
                        src: _vm._f("getProductImage")(_vm.selectedCard)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", { staticClass: "card-title" }, [
                        _vm._v(_vm._s(_vm.selectedCard.title))
                      ]),
                      _vm._v(" "),
                      _vm.isMobile()
                        ? _c("p", { staticClass: "purple-span" }, [
                            _vm._v(
                              "Type in your message below. One of our team members will hand write your message and pack it in with your box."
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "write-container",
                      class: _vm.isBlankMessage ? "blank" : ""
                    },
                    [
                      _c("div", [
                        !_vm.isMobile()
                          ? _c("p", { staticClass: "purple-span" }, [
                              _vm._v(
                                "Type in your message below. One of our team members will hand write your message and pack it in with your box."
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "blank-card-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.isBlankMessage,
                                expression: "isBlankMessage"
                              }
                            ],
                            attrs: { id: "blankCard", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.isBlankMessage)
                                ? _vm._i(_vm.isBlankMessage, null) > -1
                                : _vm.isBlankMessage
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.isBlankMessage,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.isBlankMessage = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.isBlankMessage = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.isBlankMessage = $$c
                                  }
                                },
                                function($event) {
                                  return _vm.changeBlankMessage()
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "blankCard" } }, [
                            _vm._v("Click here if you want your card blank")
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      !_vm.isBlankMessage
                        ? _c("div", { staticClass: "form-container" }, [
                            _c("div", { staticClass: "message-container" }, [
                              _c("label", { attrs: { for: "message" } }, [
                                _vm._v("Your Message:")
                              ]),
                              _vm._v(" "),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.message,
                                    expression: "message"
                                  }
                                ],
                                attrs: {
                                  placeholder: "Start typing here...",
                                  maxlength: "110",
                                  cols: "30",
                                  rows: "3",
                                  id: "message"
                                },
                                domProps: { value: _vm.message },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.message = $event.target.value
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "from-container" }, [
                              _c("label", { attrs: { for: "from" } }, [
                                _vm._v("From:")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.from,
                                    expression: "from"
                                  }
                                ],
                                attrs: {
                                  placeholder: "Your Name",
                                  maxlength: "110",
                                  id: "from",
                                  type: "text"
                                },
                                domProps: { value: _vm.from },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.from = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "purple-span",
                                  class:
                                    _vm.remainingCharacters == 0 ? "red" : ""
                                },
                                [
                                  _vm._v(
                                    "Character Remaining " +
                                      _vm._s(_vm.remainingCharacters)
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "happybox-button yellow",
                          staticStyle: { "margin-bottom": "5%" },
                          on: {
                            click: function() {
                              _vm.openCalendar = !_vm.openCalendar
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.dateButton))]
                      ),
                      _vm._v(" "),
                      _c("date-picker", {
                        attrs: {
                          id: "datepicker",
                          format: "MM-DD-YYYY",
                          type: "date",
                          valueType: "timestamp",
                          "default-value": _vm.minDate,
                          "disabled-date": _vm.disabledDates,
                          editable: false,
                          open: _vm.openCalendar
                        },
                        on: {
                          "update:open": function($event) {
                            _vm.openCalendar = $event
                          },
                          close: _vm.checkDate
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "footer",
                              fn: function(ref) {
                                var emit = ref.emit
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "mx-btn mx-btn-text",
                                          on: {
                                            click: function($event) {
                                              return _vm.clearDate(emit)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            Clear\n                        "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3170136928
                        ),
                        model: {
                          value: _vm.selectedDate,
                          callback: function($$v) {
                            _vm.selectedDate = $$v
                          },
                          expression: "selectedDate"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "complete-box" }, [
                        _c(
                          "button",
                          {
                            staticClass: "happybox-button green border",
                            class: _vm.isLoading ? "isLoading" : "",
                            attrs: { disabled: _vm.buttonDisabled },
                            on: { click: _vm.bundle }
                          },
                          [_vm._v(_vm._s(_vm.buttonText))]
                        )
                      ])
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.oosIsActive
        ? _c("OOSPopUp", {
            attrs: {
              oosProducts: _vm.noStockItems,
              firstStateProducts: _vm.currentStateSelectedAddons,
              fromSavedCart: true,
              fromCurated: false
            },
            on: {
              goback: function($event) {
                return _vm.goToAddonSelection()
              },
              continuesaved: function($event) {
                return _vm.bundle()
              },
              continuecurated: function($event) {
                return _vm.bundle()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading && _vm.cardSkipped
        ? _c("div", { staticClass: "global-spinner-container" }, [
            _c("div", { staticClass: "global-spinner" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.filterIsShown
        ? _c("CardFilter", {
            attrs: { occasionFilters: _vm.occasionFilters },
            on: {
              closefilter: function($event) {
                return _vm.showFilters()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.messageModal
        ? _c(
            "div",
            {
              staticClass: "message-modal",
              on: {
                click: function() {
                  this$1.messageModal = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-container",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "x",
                    attrs: {
                      src:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652",
                      alt: "x"
                    },
                    on: {
                      click: function() {
                        this$1.messageModal = false
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "title" }, [
                    _vm._v("Pick one of the curated messages")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.messages, function(message) {
                    return _c("div", { staticClass: "input-container" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedMessage,
                            expression: "selectedMessage"
                          }
                        ],
                        attrs: { type: "radio" },
                        domProps: {
                          value: message,
                          checked: _vm._q(_vm.selectedMessage, message)
                        },
                        on: {
                          change: function($event) {
                            _vm.selectedMessage = message
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "huey" } }, [
                        _vm._v(_vm._s(message))
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "buttons" }, [
                    _c(
                      "button",
                      {
                        staticClass: "happybox-button white border",
                        on: {
                          click: function() {
                            this$1.messageModal = false
                          }
                        }
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "happybox-button green border",
                        attrs: { disabled: !_vm.selectedMessage },
                        on: {
                          click: function() {
                            this$1.message = this$1.selectedMessage
                            this$1.messageModal = false
                          }
                        }
                      },
                      [_vm._v("Apply")]
                    )
                  ])
                ],
                2
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"
        }
      }),
      _vm._v("\n                Filter by:\n            ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }